import styled from 'styled-components';

export const FooterContainer = styled.div.attrs({})`
  background: ${(props) => props.theme.palette.primary.main};
  padding: 20px 0;
`;

export const FooterLogo = styled.img.attrs({
  src: '/logo1024.png',
})`
  width: 184px;
`;

export const FooterTitle = styled.div.attrs({})`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.palette.colors.white};
  margin-bottom: 10px;
`;

export const FooterLink = styled.div.attrs({})`
  font-size: 20px;
  color: ${(props) => props.theme.palette.colors.white};
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const FooterLinkImage = styled.img.attrs({})`
  height: 22px;
  width: 22px;
  margin-right: 16px;
`;
